import { Directive, forwardRef, Provider } from '@angular/core';
import { CheckboxRequiredValidator, NG_VALIDATORS } from '@angular/forms';

export const PHX_CHECKBOX_REQUIRED_VALIDATOR: Provider = {
  provide: NG_VALIDATORS,
  useExisting: forwardRef(() => PhxCheckboxRequiredValidatorDirective),
  multi: true,
};

@Directive({
  selector: `phx-checkbox[required][formControlName],
             phx-checkbox[required][formControl],
             phx-checkbox[required][ngModel]`,
  providers: [PHX_CHECKBOX_REQUIRED_VALIDATOR],
})
export class PhxCheckboxRequiredValidatorDirective extends CheckboxRequiredValidator { }
